export enum PolicyPaymentWorkflow {
  POLICY_PAYMENT = 'POLICY_PAYMENT',
  POLICY_PAYMENT_WITH_DELIVERY = 'POLICY_PAYMENT_WITH_DELIVERY',
  POLICY_PAYMENT_FROM_DASHBOARD = 'POLICY_PAYMENT_FROM_DASHBOARD',
  POLICY_CASCO_PAYMENT_FROM_DASHBOARD = 'POLICY_CASCO_PAYMENT_FROM_DASHBOARD',
}
